import React from "react";
import Avatar from "@mui/material/Avatar";
import "./ProfilePopup.css";
import { IP } from "../../internalServer";
import { useNavigate } from "react-router-dom";

export default function ProfilePopup({
  setProfile,
  userInfo,
  setIsPopupOpen,
  subjectTeacherArray,
  coodinatorArray,
  classTeacherArray,
}) {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    setIsPopupOpen(false);
    subjectTeacherArray = [];
    coodinatorArray = [];
    classTeacherArray = [];
  };
  //let name = JSON.parse(localStorage.getItem("UserName"));
  return (
    <>
      <div className="total_container_profile">
        <div className="profilePopUp_container1">
          {/* <Avatar
                        className="Avatar_Icon"
                        alt="XploreSense"
                        src={`${
                                userInfo?.profile_picture
                              ? `${IP}${userInfo.profile_picture.substring(
                                userInfo.profile_picture.indexOf("/")
                                )}`
                              : "/images/7.jpeg"
                          }`}
                        //src="/images/7.jpeg"
                    /> */}
          <img
            src={
              userInfo?.profile_picture
                ? IP + userInfo?.profile_picture.replace(/^\./, "")
                : userInfo?.gender === "M"
                  ? "/images/Teacher_Male.jpg"
                  : userInfo?.gender === "F"
                    ? "/images/Teacher_Female.png"
                    : "/images/default-profile.png"
            }
            alt="icon"
            className="profilePicImg"
            style={{ width: "45px", height: "43px", borderRadius: "50%" }}
            onError={(e) => {
              // This function will run if the image fails to load
              if (userInfo?.gender === "M") {
                e.target.src = "/images/Teacher_Male.jpg";
              } else if (userInfo?.gender === "F") {
                e.target.src = "/images/Teacher_Female.png";
              } else {
                e.target.src = "/images/default-profile.png";
              }
            }}
          />
          <span className="popUp_text_profile">{userInfo?.name}</span>
        </div>
        <div className="profilePopUp_container2">
          <img
            className="popUp_text_profile"
            src="/DCM-img/accountLogo.png"
            alt="Account logo"
          ></img>
          <div
            onClick={(e) => {
              setProfile(true);
            }}
          >
            View Profile
          </div>
        </div>
        <div className="profilePopUp_container2">
          <img
            className="popUp_text_profile"
            src="/DCM-img/LogOut.png"
            alt="LogOut logo"
          ></img>
          <div onClick={handleLogout}>Log out</div>
        </div>
      </div>
    </>
  );
}
